import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconUsersEdit = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 30,
	height: 27,
	viewBox: "0 0 30 27",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M12.6683 13.1335C16.0189 13.1335 18.7351 10.4173 18.7351 7.06677C18.7351 3.71619 16.0189 1 12.6683 1C9.31774 1 6.60156 3.71619 6.60156 7.06677C6.60156 10.4173 9.31774 13.1335 12.6683 13.1335Z",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1 26.2007C1.73939 23.5782 3.2659 21.2634 5.3613 19.5871C7.45671 17.9108 10.0137 16.9588 12.6669 16.8672C18.0077 16.8672 22.5578 20.7472 24.3337 26.2007",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M22.3805 3.80029C23.3918 4.28436 24.2101 5.05855 24.7151 6.0091C25.2201 6.95963 25.3853 8.0363 25.1862 9.08096C24.987 10.1256 24.4342 11.083 23.609 11.8126C22.7839 12.542 21.7296 13.0051 20.6016 13.1338",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.5332 16.8672C23.2868 17.2762 24.8954 18.0923 26.2034 19.237C27.5115 20.3815 28.4747 21.8156 29 23.4006",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.7914 21.4355L11.57 24.6475C11.2472 24.963 10.3042 25.1144 10.0827 24.8998C9.99859 24.6518 9.97821 24.3866 10.0235 24.1286C10.0689 23.8706 10.1785 23.6281 10.3422 23.4233L13.5636 20.205C13.7312 20.0641 13.9458 19.9913 14.1648 20.0008C14.3838 20.0104 14.5912 20.1016 14.7458 20.2566C14.9004 20.4115 14.9909 20.6188 14.9994 20.8372C15.0078 21.0556 14.9336 21.2691 14.7914 21.4355Z",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgIconUsersEdit;
